import {Fieldset} from "primereact/fieldset";
import HeaderBreadCrumb from "../../components/BreadCrumb/Breadcrumb";
import React, {useEffect, useState} from "react";
import {findAllRolesRules, findAllRules, updateRolesRules} from "../../api/authorization/authorization-service";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Checkbox} from "primereact/checkbox";
import classes from "./PermissionScreen.module.css";
import {getRoles} from "../../api/dataCollection/particpants-service";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import {updateProperty} from "../../api/utils/conditions-utils";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import {MultiSelect} from "primereact/multiselect";
import {Tooltip} from "primereact/tooltip";
import {classNames} from "primereact/utils";

const PermissionScreen = () => {
    const [crumbItems, setCrumbItems] = useState(["Permissions"]);
    const [groupedRules, setGroupedRules] = useState([]);
    const [synchronizedPemmdbRoles, setSynchronizedPemmdbRoles] = useState([]);
    const [allRules, setAllRules] = useState([]);
    const [permissions, setPermissions] = useState({})
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [chosenRoles, setChosenRoles] = useState([]);
    useEffect(() => {

        getRoles().then(r => {
            setSynchronizedPemmdbRoles(r.content)
        })
        var all_rules = [];
        findAllRules().then(result => {
            all_rules = result.content
            setAllRules(result.content)
        })
        findAllRolesRules().then(res => {
            var associated_rules_ids = res.content.map(x => x.rule.id)
            var rulesNotFoundInRoleRule = all_rules.filter(r => associated_rules_ids.filter(x => x === r.id).length === 0)
            const groupedData = res.content.reduce((acc, item) => {
                const context = item.rule.context;
                const ruleName = item.rule.name;

                if (!acc[context]) {
                    acc[context] = {};
                }
                if (!acc[context][ruleName]) {
                    acc[context][ruleName] = [];
                }
                acc[context][ruleName].push(item);
                return acc;
            }, {});
            rulesNotFoundInRoleRule.forEach((row) => {
                if (!groupedData[row.context]) {
                    groupedData[row.context] = {};
                }
                groupedData[row.context][row.name] = [];
            });
            setGroupedRules(groupedData)
        })
    }, [])

    useEffect(() => {

        const initial = {};
        if (groupedRules.length !== 0) {
            for (const [context, rulesByName] of Object.entries(groupedRules)) {
                initial[context] = {};
                for (const [ruleName, items] of Object.entries(rulesByName)) {
                    initial[context][ruleName] = {};
                    for (const item of items) {
                        const roleName = item.role.name;
                        initial[context][ruleName][roleName] = true;
                    }
                }
            }
            setPermissions(initial);
            setIsLoading(false)
        }
    }, [groupedRules])
    useEffect(() => {
        setUpdateTrigger(prev => prev + 1)
    }, [chosenRoles]);
    const handleTogglePermission = (context, ruleName, roleName) => {
        setPermissions((prev) => {
            const currentValue = prev?.[context]?.[ruleName]?.[roleName] || false;
            return {
                ...prev,
                [context]: {
                    ...prev[context],
                    [ruleName]: {
                        ...prev[context][ruleName],
                        [roleName]: !currentValue,
                    },
                },
            };
        });
        setUpdateTrigger(prev => prev + 1);
    };

    const updateRolesRulesObj = () => {
        const flatList = [];
        for (const context of Object.keys(permissions)) {
            for (const ruleName of Object.keys(permissions[context])) {
                for (const roleName of Object.keys(permissions[context][ruleName])) {
                    const isChecked = permissions[context][ruleName][roleName];
                    if (isChecked) {
                        const item = groupedRules?.[context]?.[ruleName]?.find(i => i.role.name === roleName);
                        if (item) {
                            flatList.push(item);
                        } else {
                            const ruleObj = allRules.find(ar => ar.name === ruleName);
                            const roleObj = synchronizedPemmdbRoles.find(ro => ro.name === roleName);
                            flatList.push({
                                rule: ruleObj,
                                role: roleObj
                            });
                        }
                    }
                }
            }
        }
        updateRolesRules(flatList).then(r => {
        });
    };
    const ruleBody = (row) => {
        var ruleDescription = allRules.find(r => r.name === row).description;
        return (
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
            }}>
                <p style={{margin: 0}}>{row}</p>
                <Tooltip target=".pi-info-circle"/>
                <span
                    className="pi pi-info-circle"
                    style={{fontSize: '0.9rem'}} data-pr-tooltip={ruleDescription}
                />
            </div>
        );
    };
    return updateProperty(isLoading
        , (<LoadingScreen/>)
        , (
            <div>
                <div className={classes.floatingBar}>
                    <Button className={classes.actionBtn}
                            label="Save Changes"
                            icon="pi pi-save"
                            onClick={updateRolesRulesObj}
                    />
                </div>
                <HeaderBreadCrumb items={crumbItems}/>
                <div className={classes.container}>
                    <h3>Manage permissions</h3>
                </div>
                <br/>
                <div>
                    <p><b>Assign permissions for these roles </b></p>
                    <MultiSelect
                        options={synchronizedPemmdbRoles} fixedPlaceholder={true}
                        className={classes.dropDown} value={chosenRoles}
                        onChange={(e) => {
                            setChosenRoles(e.target.value);
                        }}
                        optionLabel="name"
                        placeholder="Select roles" filter/>
                </div>
                <br></br>
                {chosenRoles.length === 0 ? null : Object.entries(groupedRules).map(([context, rulesByName]) => (
                    <div key={context}>
                        <Fieldset toggleable legend={context}>
                            <DataTable key={updateTrigger}
                                       value={Object.entries(rulesByName)}
                                       tableStyle={{minWidth: '50rem'}}
                                       className={classes.customDataTable}
                            >
                                <Column headerClassName={classNames(classes.customDataTable, "centered-header")}
                                        header="Feature / Role"
                                        body={([ruleName]) => ruleBody(ruleName)}
                                        style={{fontWeight: 'bold', width: '20rem', fontSize: '0.9rem'}}
                                />

                                {chosenRoles.map((r) => (
                                    <Column
                                        key={r.name}
                                        header={r.name}
                                        headerClassName={classNames(classes.customDataTable, "centered-header")}
                                        style={{maxWidth: '15rem'}}
                                        body={([ruleName]) => (
                                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                                <Checkbox className={classes.customCheckbox}
                                                          inputId={`${context}-${ruleName}-${r.name}`}
                                                          checked={permissions?.[context]?.[ruleName]?.[r.name] || false}
                                                          onChange={() => handleTogglePermission(context, ruleName, r.name)}
                                                />
                                            </div>
                                        )}

                                    />
                                ))}
                            </DataTable>
                        </Fieldset>
                        <br/>
                    </div>
                ))}
                <br/>
                <br/>
            </div>
        ))
};

export default PermissionScreen;